<template>
    <!-- 我的发票 -->
    <div class="wid-100">
        <!--  -->
        <div class="" style="" v-show="$route.meta.showFather && this.$route.fullPath =='/personal/service/invoice/myInvoice'">
            <div class="box-shadow mb-16" v-for="(item,index) in voiceList" :key="index">
                <div :class="item.status==2000 ?'col-1':item.status==1000?'col-3':'col-2'" class="status font-1">
                    <span>发票状态:</span>
                    {{item.status==1000 ? '开票中' : item.status==2000 ? '已开票' : '已驳回' }}
                </div>
                <div class="flex-1 jus-bet pad-36">
                    <div class="flex-1">
                        <p class="tiantou font-1">发票总额:</p>
                        <p class="money font-1">￥{{item.amount}}</p>
                    </div>
                    <div class="flex-1">
                        <p class="tiantou font-1">抬头类型:</p>
                        <p class="names font-1">{{item.headingType==1?'个人':'企业'}}</p>
                    </div>
                    <div class="flex-1">
                        <p class="tiantou font-1">申请时间:</p>
                        <p class="names font-1">{{utils.getNowTime(item.createTime)}}</p>
                    </div>
                    <div class="flex-1 cursor" @click="details(item.id)">
                        <p class="details font-1">查看详情</p>
                        <i class="el-icon-arrow-right" style="color: #999999;font-size: 14px;"></i>
                    </div>
                </div>
            </div>
            <el-pagination v-show="pageInline.tableTotal>0" @size-change="handleSizeChange"
                @current-change="handleCurrentChange" :page-sizes="pageGroup.sizes" :page-size="pageGroup.size"
                layout="total, sizes, prev, pager, next, jumper" :total="pageInline.tableTotal">
            </el-pagination>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>
    import {
        getInvoiceList
    } from '@/api/personal/api.js';
    export default {
        components: {},
        data() {
            return {
                voiceList: [],
                page: 1,
                limit: this.pageGroup.size,
                //分页对象
                pageInline: {
                    tableSizes: this.pageGroup.sizes, //显示条数分组
                    tableTotal: 10, // 默认数据总数
                },
            }

        },
        mounted() {
            this.getList()
        },
        methods: {
            getList() {
                let params = {
                    pageNo:this.page,
                    pageSize:this.limit,
                }
                getInvoiceList(params).then(res => {
                        this.voiceList = res.data.list;
                        this.pageInline.tableTotal = res.data.total;
                    })
                    .catch(error => {
            
                    });
            },
            //页容量改变时会触发
            handleSizeChange(size) {
                this.limit = size;
                this.getInit(this.status);
            },
            //当前页改变时会触发
            handleCurrentChange(currentPage) {
                console.log(currentPage,'currentPage')
                this.page = currentPage;
                this.getInit(this.status);
            },
            details(id) {
                this.$router.push({
                    name:'/invoice/invoiceDetail',
                    params:{id:id}
                })
                // console.log(this.$route.query.status,'cecece')
            }
        }
    }
</script>

<style>

</style>
<style scoped>
    .box-shadow {
        box-shadow: 2px 2px 8px 0px rgba(195, 219, 255, 0.25);
        border-radius: 8px 8px 8px 8px;
    }

    .pad-36 {
        padding: 36px 16px 51px 16px;
    }

    .flex-1 {
        display: flex;
        align-items: center;
    }

    .jus-bet {
        justify-content: space-between;
    }

    .status {

        border-radius: 8px 8px 0 0;
        padding: 6px 0 5px 16px;
    }

    .status span {
        padding-right: 16px;
    }

    .tiantou {
        color: #999999;
        padding-right: 16px;
    }

    .money {
        color: #FFBA31;
    }

    .font-1 {
        font-size: 14px;
        line-height: 21px;
    }

    .names {
        color: #222222;
    }

    .details {
        color: #333333;
        padding-right: 8px;
    }

    .mb-16 {
        margin-bottom: 16px;
    }

    .col-1 {
        color: #3ECC64;
        background-color: #EBFAEF;
    }

    .col-2 {
        color: #FF534D;
        background-color: #FFF0F0;
    }

    .col-3 {
        color: #FBB54C;
        background-color: #FFF6F0;
    }
</style>
